// extracted by mini-css-extract-plugin
export var avatar = "_mw-3";
export var avatarContainer = "_mw-2";
export var avatarSpacer = "_mw-5";
export var avatarSpacerContainer = "_mw-4";
export var avatarStackContainer = "_mw-1";
export var bubble = "_mw-0";
export var remainderBubble = "_mw-6";